import { render } from "./TerminateSilently.vue?vue&type=template&id=796f9c5a&scoped=true"
import script from "./TerminateSilently.vue?vue&type=script&lang=js"
export * from "./TerminateSilently.vue?vue&type=script&lang=js"

import "./TerminateSilently.vue?vue&type=style&index=0&id=796f9c5a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796f9c5a"]])

export default __exports__